import { useEffect, useState } from 'react';

import { msAllaScadenza } from '@/lib/limulo/scadenzaRisultato';

/**
 * Ridisegna il componente UNA volta, alla scadenza (kb#343): niente countdown, niente tick a schermo.
 * La frase «il risultato arriva entro le HH:MM» e' vera finche' l'orario non passa; a schermo aperto oltre
 * quell'orario direbbe una cosa falsa, e il refetch non e' garantito. Il componente rilegge `Date.now()` a ogni
 * disegno (come `useCountdown`): qui si forza SOLO il disegno.
 *
 * · UN timeout alla volta, cancellato allo smontaggio e quando la scadenza cambia (pausa, dato nuovo);
 * · se scatta qualche ms prima (i timer del browser non garantiscono l'istante), il giro successivo ne arma un
 *   altro per il resto: la frase non resta «entro» un attimo dopo la scadenza;
 * · scadenza assente, invalida, gia' arrivata o oltre il massimo di un timeout: niente timer.
 */
export function useRidisegnaAllaScadenza(scadenza: string | null | undefined): void {
  const [giro, setGiro] = useState(0);
  useEffect(() => {
    const ms = msAllaScadenza(scadenza, Date.now());
    if (ms === null) return;
    const id = window.setTimeout(() => setGiro((n) => n + 1), ms);
    return () => window.clearTimeout(id);
  }, [scadenza, giro]);
}
